export const createMetadataSpaceHeader = (spaceId: string) => ({
  'grpc-metadata-space': spaceId,
})
